export class ContractMap {
  contractId: number;
  description: string;
}
